import React from 'react';
import { TailSpin } from 'react-loader-spinner'; // Import TailSpin spinner

const Spinner = () => {
    return (
        <div className="spinner-container">
            <TailSpin color="#00BFFF" height={50} width={50} />
        </div>
    );
};

export default Spinner;
